import React from "react";
import { Link } from "react-router-dom";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Book from "@material-ui/icons/Book";
// import { CheckCircle } from "@material-ui/icons"

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import Next from '@material-ui/icons/ArrowForward';

// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemText from '@material-ui/core/ListItemText';
// import ListIcon from '@material-ui/icons/RemoveFromQueue';


import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";


const dashboardRoutes = [];

class LandingPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  buttonClick = (link) => {
    if (link === 'home') {
      this.props.history.push('home')
    } else if (link === 'about') {
      this.props.history.push('about')
    } else if (link === 'newsresources') {
      this.props.history.push('newsresources')
    } else if (link === 'service') {
      this.props.history.push('service')
    } else if (link === 'career') {
      this.props.history.push('career')
    } else if (link === 'getintouch') {
      this.props.history.push('getintouch')
    } else if (link === 'gallery') {
      this.props.history.push('gallery')
    } else {
      this.props.history.push('/')
    }
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="SANDTON CONSULTING"
          rightLinks={<HeaderLinks onButtonClick={this.buttonClick} />}
          fixed
          changeColorOnScroll={{
            height: 10,
            color: "primary"
          }}
          {...rest}
        />
        <Parallax filter image={require("assets/img/landing-bg.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <h1 className={classes.title}>READY TO WORK TOGETHER ?</h1>
                <h4>
                  We has extensive experience in guiding National and Multinational companies to design and implement an effective Management System such as Quality, Safety & Environmental Systems, Business Process Management, Human Resources Management.
                </h4>
                <br />
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={10} lg={10} className={classes.navWrapper}>
                <NavPills
                  alignCenter
                  color="primary"
                  tabs={[
                    {
                      tabButton: "CONSULTAN",
                      tabIcon: Book,
                      tabContent: (
                        <div>
                          <Card>
                            <CardBody>
                              <Link to="/career/iso27001consultant">
                                <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                  <b>
                                    ISO 27001 CONSULTANT
                                </b>
                                </h3>
                              </Link>
                              <span style={{ color: "grey", marginTop: 0 }}><b>December 17, 2018 </b> </span><br /><br />
                              <Link to="/career/iso27001consultant"><b>Read more&nbsp;&nbsp; ></b></Link>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <Link to="/career/iso37001consultant">
                                <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                  <b>
                                    ISO 37001 CONSULTANT
                                </b>
                                </h3>
                              </Link>
                              <span style={{ color: "grey", marginTop: 0 }}><b>December 10, 2018 </b> </span><br /><br />
                              <Link to="/career/iso37001consultant"><b>Read more&nbsp;&nbsp; ></b></Link>
                            </CardBody>
                          </Card>
                          {/* <Card>
                            <CardBody>
                              <Link to="/career/consultaniso27001">
                                <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                  <b>
                                    IT Development System
                                </b>
                                </h3>
                              </Link>
                              <span style={{ color: "grey", marginTop: 0 }}><b>December 10, 2018 </b> </span><br /><br />
                              <Link to="/career/consultaniso27001"><b>Read more&nbsp;&nbsp; ></b></Link>
                            </CardBody>
                          </Card> */}
                        </div>
                      )
                    },
                    {
                      tabButton: "BUSSINESS DEVELOPMENT",
                      tabIcon: Book,
                      tabContent: (
                        <GridContainer>
                          <Card>
                            <CardBody>
                              <br />
                              <Link to="/career/marketing">
                                <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                  <b>
                                    MARKETING
                                </b>
                                </h3>
                              </Link>
                              <span style={{ color: "grey", marginTop: 0 }}><b>December 17, 2018 </b> </span><br /><br />
                              <Link to="/career/marketing"><b>Read more&nbsp;&nbsp; ></b></Link>
                            </CardBody>
                          </Card>
                        </GridContainer>
                      )
                    },
                    {
                      tabButton: "IT MANAGER",
                      tabIcon: Book,
                      tabContent: (
                        <GridContainer>
                          <Card>
                            <CardBody>
                              <br />
                            </CardBody>
                          </Card>
                        </GridContainer>
                      )
                    },
                  ]}
                />
              </GridItem>
            </GridContainer>
            <br />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(LandingPage);



// WEBPACK FOOTER //
// ./src/views/CareerPage/LandingPage.jsx